<template>
    <v-text-field
        dense
        flat
        hide-details
        rounded
        v-if="visible"
        :placeholder="placeholder"
        prepend-icon="mdi-magnify"
        ref="search"
        solo-inverted
        v-model="searchText"
        append-icon="mdi-close"
        @click:append="clearText"
        data-testid="search-field"
    ></v-text-field>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'toolbar-search',
  computed: {
    ...mapGetters({
      visible: 'search/visible',
      placeholder: 'search/placeholder',
      getSearchText: 'search/searchText'
    }),
    searchText: {
      get () {
        return this.getSearchText
      },
      set (searchText) {
        this.setSearchText(searchText)
      }
    }
  },
  watch: {
    $route (to, from) {
      this.close()
    }
  },
  methods: {
    ...mapActions({
      setSearchText: 'search/setSearchText',
      close: 'search/close'
    }),
    clearText () {
      this.setSearchText('')
    }
  }
}
</script>

<style>
</style>
